/* Whiskey Pop jukebox — the machine is the player.
   Audio only ever starts from an explicit user gesture. */
(function () {
  var KEY = 'wp-juke-state', VOLKEY = 'wp-juke-vol';
  var audio = document.getElementById('wp-juke-audio');
  var bar = null;
  var juke = document.querySelector('[data-juke]');
  var hero = document.querySelector('.wpn-hero');

  /* hero: static. (The scroll-driven zoom was removed Sept 13 2026 — nothing on the site resizes while scrolling.) */

  if (!audio || !juke) return;

  var rows = Array.prototype.slice.call(juke.querySelectorAll('[data-track]'));
  var recs = Array.prototype.slice.call(document.querySelectorAll('[data-rec]'));   /* the rack lives outside the machine section */
  var idx = -1;
  var g = function (s) { return juke.querySelector(s) || document.querySelector(s); };
  var ctrlEl = juke.querySelector('.wpn__ctrl'); if (ctrlEl) document.body.appendChild(ctrlEl);   /* fixed card lives at the root: nothing on the page can stack over it */
  var stateEl = g('[data-now-state]'), stateIdle = stateEl ? stateEl.textContent : 'Ready';


  function read(row) {
    return { code: row.getAttribute('data-code'), title: row.getAttribute('data-title'),
      artist: row.getAttribute('data-artist'), time: row.getAttribute('data-time'), src: row.getAttribute('data-src') || '', art: row.getAttribute('data-art') || '' };
  }
  function fmt(s) { if (!isFinite(s) || s < 0) return '--:--'; s = Math.floor(s); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function save() {}                                            /* playback lives and dies on this page */
  function setState(txt) { if (stateEl) stateEl.textContent = txt; }

  /* ---- mechanical sounds, synthesised (no files, only after a gesture) ---- */
  var actx = null;
  function ctx() { var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return null; if (!actx) { try { actx = new AC(); } catch (e) { return null; } } if (actx.state === 'suspended') actx.resume().catch(function () {}); return actx; }
  function click(kind) {
    var c = ctx(); if (!c) return;
    var t = c.currentTime, len = kind === 'thunk' ? 0.09 : 0.03;
    var buf = c.createBuffer(1, Math.floor(c.sampleRate * len), c.sampleRate), d = buf.getChannelData(0);
    for (var i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, kind === 'thunk' ? 3 : 6);
    var src = c.createBufferSource(); src.buffer = buf;
    var f = c.createBiquadFilter(); f.type = kind === 'thunk' ? 'lowpass' : 'bandpass'; f.frequency.value = kind === 'thunk' ? 380 : 2600; f.Q.value = 1.2;
    var gn = c.createGain(); gn.gain.value = kind === 'thunk' ? 0.55 : 0.32;
    src.connect(f); f.connect(gn); gn.connect(c.destination); src.start(t);
    if (kind === 'thunk') {
      var o = c.createOscillator(), og = c.createGain(); o.type = 'sine'; o.frequency.setValueAtTime(140, t); o.frequency.exponentialRampToValueAtTime(60, t + 0.12);
      og.gain.setValueAtTime(0.25, t); og.gain.exponentialRampToValueAtTime(0.001, t + 0.16); o.connect(og); og.connect(c.destination); o.start(t); o.stop(t + 0.18);
    }
  }

  /* ---- painting ---- */
  function paintBar() {}
  function paintJuke(t, playing) {
    var set = function (sel, v) { var e = g(sel); if (e) e.textContent = v; };
    set('[data-now-code]', t.code || '--'); set('[data-now-title]', t.title || ''); set('[data-now-artist]', t.artist || '');
    if (prog && idx !== lastIdx) { prog.style.setProperty('--p', '0%'); lastIdx = idx; }
    var d = g('[data-dur]'); if (d) d.textContent = t.time || '--:--';
    juke.classList.toggle('is-playing', !!playing); document.body.classList.toggle('wpj-playing', !!playing);
    juke.classList.toggle('has-track', picked && !!t.src); document.body.classList.toggle('wpj-has-track', picked && !!t.src);
    var nos = g('[data-nosrc]'); if (nos) nos.hidden = !!t.src;
    rows.forEach(function (r, i) { r.classList.toggle('is-cued', i === idx); });
    recs.forEach(function (r) { r.classList.toggle('is-cued', +r.getAttribute('data-rec') === idx); });
    setState(playing ? 'Now playing' : (t.src ? 'Cued' : 'No record'));
    mediaSession(t);
  }

  var switching = false, picked = false, lastIdx = -1;
  function play(i, seek) {
    if (!rows.length) return;
    picked = true;
    idx = (i + rows.length) % rows.length;
    var t = read(rows[idx]);
    switching = !audio.paused && !!t.src;
    paintJuke(t, switching); paintBar(t, switching);
    if (!t.src) { save(t, false); return; }                       /* pressed-but-silent: show the state, play nothing */
    if (audio.getAttribute('src') !== t.src) { audio.setAttribute('src', t.src); audio.load(); }
    if (seek) { try { audio.currentTime = seek; } catch (e) {} }
    click('thunk');
    setTimeout(function () {
      audio.play().then(function () { paintJuke(t, true); paintBar(t, true); save(t, true); })
        .catch(function () { switching = false; paintJuke(t, false); paintBar(t, false); save(t, false); });
    }, 140);
  }
  function toggle() {
    if (audio.paused) { if (!audio.getAttribute('src')) { play(idx < 0 ? 0 : idx); return; } ctx(); audio.play().catch(function () {}); }
    else { audio.pause(); }
  }
  /* first-visit hint bubble: shows when the machine scrolls into view, once per session */
  var HINTKEY = 'wp-juke-hint', hintEl = document.querySelector('[data-hint]'), hintShown = false;
  function hideHint(remember) {
    if (!hintEl || hintEl.hidden) return; hintEl.classList.add('is-out'); setTimeout(function () { hintEl.hidden = true; }, 320);
    if (remember) { try { sessionStorage.setItem(HINTKEY, '1'); } catch (e) {} }
  }
  function placeHint() {
    var stage = document.querySelector('.wpn__stage'), win = document.querySelector('.wpn__window'); if (!hintEl || !stage || !win) return;
    var sr = stage.getBoundingClientRect(), wr = win.getBoundingClientRect(), bw = hintEl.offsetWidth, bh = hintEl.offsetHeight;
    var roomRight = window.innerWidth - wr.right, gap = 34;
    if (roomRight >= bw + gap + 16) {           /* beside the window, tail pointing left at the strips */
      hintEl.classList.add('tail-left');
      hintEl.style.left = (wr.right - sr.left + gap) + 'px'; hintEl.style.top = (wr.top - sr.top + wr.height / 2 - bh / 2) + 'px';
    } else {                                     /* above the window, clamped to the top of the stage */
      hintEl.classList.remove('tail-left');
      hintEl.style.left = (wr.left - sr.left + wr.width / 2 - bw / 2) + 'px'; hintEl.style.top = Math.max(8, wr.top - sr.top - bh - 26) + 'px';
    }
  }
  window.addEventListener('resize', function () { if (hintEl && !hintEl.hidden) placeHint(); });
  (function () {
    if (!hintEl) return; var seen = false; try { seen = sessionStorage.getItem(HINTKEY) === '1'; } catch (e) {}
    if (seen) return;
    var stage = document.querySelector('.wpn__stage'); if (!stage || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      if (hintShown || !es[0].isIntersecting) return; hintShown = true; io.disconnect();
      setTimeout(function () { hintEl.hidden = false; hintEl.classList.remove('is-out'); placeHint(); }, 500);
      setTimeout(function () { hideHint(true); }, 9000);
    }, { threshold: 0.55 });
    io.observe(stage);
    var x = hintEl.querySelector('[data-hint-x]'); if (x) x.addEventListener('click', function (e) { e.stopPropagation(); click('tick'); hideHint(true); });
  })();

  function select(i) {
    hideHint(true);
    var row = rows[i]; if (!row) return;
    row.classList.add('is-pressed'); setTimeout(function () { row.classList.remove('is-pressed'); }, 200);
    if (idx === i && !audio.paused) { audio.pause(); return; }
    play(i);
  }

  /* ---- title strips + record sleeves ---- */
  rows.forEach(function (row, i) { row.addEventListener('click', function () { click('tick'); select(i); }); });
  recs.forEach(function (rec) { rec.querySelector('.wpn__sleeve').addEventListener('click', function () {
    var i = +rec.getAttribute('data-rec'); click('tick'); select(i);
  }); });

  /* ---- lyrics: turn a sleeve over ---- */
  function flip(rec, on) { rec.classList.toggle('is-flipped', on); }
  recs.forEach(function (rec) {
    var b = rec.querySelector('[data-lyrics]'), x = rec.querySelector('[data-back-close]'), back = rec.querySelector('[data-back]');
    if (b) b.addEventListener('click', function (e) { e.stopPropagation(); click('tick'); flip(rec, !rec.classList.contains('is-flipped')); });
    if (x) x.addEventListener('click', function (e) { e.stopPropagation(); click('tick'); flip(rec, false); });
    if (back) back.addEventListener('click', function (e) { if (e.target === back) flip(rec, false); });
  });

  /* ---- the secret side ---- */
  var SECRET = 'wp-juke-secret', secretCode = (juke.getAttribute('data-secret-code') || '').replace(/\s/g, ''), codeBuf = '';
  var unlocked = false; try { unlocked = localStorage.getItem(SECRET) === '1'; } catch (e) {}
  var hasSecret = rows.some(function (r) { return r.hasAttribute('data-secret'); });
  if (!hasSecret) unlocked = false;
  function visibleRows() { return rows.filter(function (r) { return r.hasAttribute('data-secret') === unlocked; }); }
  function applyUnlock() {
    document.body.classList.toggle('wpj-unlocked', unlocked);
    buildKeys();
  }
  function unlockChime() {
    var c = ctx(); if (!c) return; var t = c.currentTime;
    [523, 659, 784, 1046].forEach(function (f, k) { var o = c.createOscillator(), gn = c.createGain(); o.type = 'square'; o.frequency.value = f;
      gn.gain.setValueAtTime(0.0001, t + k * 0.09); gn.gain.exponentialRampToValueAtTime(0.12, t + k * 0.09 + 0.01); gn.gain.exponentialRampToValueAtTime(0.0001, t + k * 0.09 + 0.16);
      o.connect(gn); gn.connect(c.destination); o.start(t + k * 0.09); o.stop(t + k * 0.09 + 0.2); });
  }
  function toggleSecret() {
    unlocked = !unlocked; try { localStorage.setItem(SECRET, unlocked ? '1' : '0'); } catch (e) {}
    applyUnlock(); unlockChime();
    juke.classList.remove('is-unlocking'); void juke.offsetWidth; juke.classList.add('is-unlocking');
    setState(unlocked ? (juke.getAttribute('data-unlock-text') || 'Unlocked') : (juke.getAttribute('data-lock-text') || 'Locked'));
    var first = visibleRows()[0]; if (first) { idx = rows.indexOf(first); paintJuke(read(first), !audio.paused); if (!audio.paused) {} }
  }

  /* ---- physical selector buttons: letter, then number ---- */
  var armed = '';
  function buildKeys() {
    var L = g('[data-key-letters]'), N = g('[data-key-numbers]'); if (!L || !N) return;
    L.innerHTML = ''; N.innerHTML = ''; armed = '';
    var letters = [], numbers = [];
    visibleRows().forEach(function (r) {
      var m = (r.getAttribute('data-code') || '').match(/^([A-Za-z]+)\s*-?\s*(\d+)$/); if (!m) return;
      if (letters.indexOf(m[1].toUpperCase()) < 0) letters.push(m[1].toUpperCase());
      if (numbers.indexOf(m[2]) < 0) numbers.push(m[2]);
    });
    secretCode.split('').forEach(function (d) { if (/\d/.test(d) && numbers.indexOf(d) < 0) numbers.push(d); });   /* the code must always be typeable */
    numbers.sort(function (a, b) { return a - b; });
    var mk = function (txt, cls, fn) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'wpn__key ' + cls; b.textContent = txt;
      b.addEventListener('click', function () { b.classList.add('is-down'); click('tick'); setTimeout(function () { b.classList.remove('is-down'); }, 160); fn(txt, b); });
      return b;
    };
    letters.forEach(function (l) { L.appendChild(mk(l, 'wpn__key--l', function (txt, b) {
      codeBuf = ''; armed = txt; L.querySelectorAll('.wpn__key').forEach(function (k) { k.classList.toggle('is-armed', k === b); }); setState(txt + '\u2013');
    })); });
    numbers.forEach(function (n) { N.appendChild(mk(n, 'wpn__key--n', function (txt) {
      if (!armed) {
        codeBuf = (codeBuf + txt).slice(-12);
        if (hasSecret && secretCode && codeBuf.slice(-secretCode.length) === secretCode) { codeBuf = ''; toggleSecret(); return; }
        setState('Letter first'); return;
      }
      var code = armed + txt, hit = -1;
      visibleRows().forEach(function (r) { if ((r.getAttribute('data-code') || '').replace(/[\s-]/g, '').toUpperCase() === code) hit = rows.indexOf(r); });
      L.querySelectorAll('.wpn__key').forEach(function (k) { k.classList.remove('is-armed'); }); armed = '';
      if (hit < 0) { setState('No ' + code); return; }
      select(hit);
    })); });
  }
  applyUnlock();

  /* ---- transport ---- */
  if (g('[data-toggle]')) g('[data-toggle]').addEventListener('click', toggle);
  if (g('[data-prev]')) g('[data-prev]').addEventListener('click', function () { if (audio.currentTime > 3 && audio.getAttribute('src')) { audio.currentTime = 0; return; } play(idx - 1); });
  if (g('[data-next]')) g('[data-next]').addEventListener('click', function () { play(idx + 1); });

  var seek = g('[data-seek]'), cur = g('[data-cur]'), scrubbing = false;
  var prog = g('[data-progress]');
  var paintSeek = function (v) { if (seek) seek.style.setProperty('--p', (v / 10) + '%'); if (prog) prog.style.setProperty('--p', (v / 10) + '%'); var bs = bar && bar.querySelector('[data-bar-seek]'); if (bs) bs.style.width = (v / 10) + '%'; };
  if (seek) {
    seek.addEventListener('input', function () { scrubbing = true; paintSeek(seek.value); if (audio.duration && cur) cur.textContent = fmt((seek.value / 1000) * audio.duration); });
    seek.addEventListener('change', function () { if (audio.duration) audio.currentTime = (seek.value / 1000) * audio.duration; scrubbing = false; });
  }
  if (prog) {
    prog.addEventListener('click', function (e) { if (!audio.duration) return; var r = prog.getBoundingClientRect(); audio.currentTime = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1) * audio.duration; });
    prog.addEventListener('keydown', function (e) { if (!audio.duration) return; if (e.key === 'ArrowRight') { e.preventDefault(); audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); } else if (e.key === 'ArrowLeft') { e.preventDefault(); audio.currentTime = Math.max(0, audio.currentTime - 5); } });
  }
  audio.addEventListener('timeupdate', function () {
    if (!audio.duration) return;
    var v = Math.round((audio.currentTime / audio.duration) * 1000);
    if (!scrubbing) { if (seek) seek.value = v; paintSeek(v); if (cur) cur.textContent = fmt(audio.currentTime); }
    var bc = bar && bar.querySelector('[data-bar-cur]'); if (bc) bc.textContent = fmt(audio.currentTime);
    if (idx >= 0 && !audio.paused && Math.floor(audio.currentTime) % 5 === 0) save(read(rows[idx]), true);
  });
  audio.addEventListener('loadedmetadata', function () {
    if (!isFinite(audio.duration)) return;
    var d = g('[data-dur]'); if (d) d.textContent = fmt(audio.duration);
    var bd = bar && bar.querySelector('[data-bar-dur]'); if (bd) bd.textContent = fmt(audio.duration);
  });

  var vol = g('[data-vol]'), mute = g('[data-mute]'), v0 = 80;
  try { v0 = parseInt(localStorage.getItem(VOLKEY) || '80', 10); } catch (e) {}
  audio.volume = v0 / 100;
  if (vol) { vol.value = v0; vol.style.setProperty('--p', v0 + '%');
    vol.addEventListener('input', function () { audio.volume = vol.value / 100; audio.muted = false; vol.style.setProperty('--p', vol.value + '%'); if (mute) mute.classList.remove('is-off'); try { localStorage.setItem(VOLKEY, vol.value); } catch (e) {} }); }
  if (mute) mute.addEventListener('click', function () { audio.muted = !audio.muted; mute.classList.toggle('is-off', audio.muted); });

  document.addEventListener('keydown', function (e) {
    var tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'button' || e.metaKey || e.ctrlKey) return;
    if (e.code === 'Space') { e.preventDefault(); toggle(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); if (e.shiftKey) play(idx + 1); else if (audio.duration) audio.currentTime = Math.min(audio.duration, audio.currentTime + 5); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); if (e.shiftKey) play(idx - 1); else audio.currentTime = Math.max(0, audio.currentTime - 5); }
  });


  audio.addEventListener('play', function () { switching = false; document.documentElement.classList.add('wpj-on'); if (bar) bar.classList.add('is-playing'); juke.classList.add('is-playing'); document.body.classList.add('wpj-playing'); setState('Now playing'); });
  audio.addEventListener('pause', function () { if (switching || (audio.ended && idx < rows.length - 1)) return; if (bar) bar.classList.remove('is-playing'); juke.classList.remove('is-playing'); document.body.classList.remove('wpj-playing'); setState(audio.ended ? 'Ready' : 'Paused'); if (idx >= 0) save(read(rows[idx]), false); });
  audio.addEventListener('ended', function () { if (idx === rows.length - 1) { juke.classList.remove('is-playing'); document.body.classList.remove('wpj-playing'); setState('Ready'); return; } play(idx + 1); });
  audio.addEventListener('error', function () { setState('No record'); });

  function mediaSession(t) {
    if (!('mediaSession' in navigator)) return;
    try {
      navigator.mediaSession.metadata = new MediaMetadata({ title: t.title || 'Whiskey Pop', artist: t.artist || '', album: 'The Whiskey Pop Jukebox', artwork: t.art ? [{ src: t.art, sizes: '400x400' }] : [] });   /* sleeve on the lock screen */
      navigator.mediaSession.setActionHandler('play', function () { toggle(); });
      navigator.mediaSession.setActionHandler('pause', function () { audio.pause(); });
      navigator.mediaSession.setActionHandler('previoustrack', function () { play(idx - 1); });
      navigator.mediaSession.setActionHandler('nexttrack', function () { play(idx + 1); });
    } catch (e) {}
  }

  if (rows.length) { var first0 = visibleRows()[0] || rows[0]; idx = rows.indexOf(first0); paintJuke(read(first0), false); setState(stateIdle); }
})();
